import {
    checkDateIsToday,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import React, {useEffect, useState} from "react";
import MealsItem from "./mealsItem/MealsItem";
import RaikoHostSelectBox from "../../../component/hostSelect/selectBox/RaikoHostSelectBox";
import {css} from "@emotion/css";

export default function TotalMealsPerHost({periodId,refreshFlag}) {

    const service = new HabitationMonitoringService()
    const [selectedHost, setSelectedHost] = useState(-1)
    const [loading, setLoading] = useState(false)

    const [dailyMealsData, setDailyMealsData] = useState({
        breakfast: 0,
        lunch: 0,
        dinner: 0
    })

    function getDataFromServer() {
        setLoading(true)
        service.getHostDailyReservation(periodId, selectedHost)
            .then(response => {
                setDailyMealsData([])
                response.items.map((item) => {
                    if (checkDateIsToday(item.date)) {
                        setDailyMealsData({
                            breakfast: item.numberOfExit + item.numberOfResident,
                            lunch: item.numberOfResident,
                            dinner: item.numberOfResident + item.numberOfEntries
                        })
                    }
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0 && typeof selectedHost !== 'undefined' && selectedHost !== -1) {
            getDataFromServer()
        }
    }, [periodId, selectedHost]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return (
        <RaikoBaseCardContainer className={css`overflow: hidden`}>

            <RaikoGridOneColumn>

                <RaikoLabel text={"وعده های غذایی امروز به تفکیک اقامتگاه"}/>
                <RaikoHostSelectBox
                    periodId={periodId}
                    isHorizontal={true}
                    setSelectedHost={setSelectedHost}
                    selectedHost={selectedHost}
                />
                <MealsItem
                    breakfast={dailyMealsData.breakfast}
                    lunch={dailyMealsData.lunch}
                    dinner={dailyMealsData.dinner}
                    loading={loading}
                />
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}